import { serialize } from 'core/utils/objectUtils';

export function withQueryParams(endpoint, params) {
	let qs = serialize(params);
	if (qs) {
		let delimiter = (endpoint.indexOf('?') === -1) ? '?' : '&';
		endpoint += delimiter + qs;
	}
	return endpoint;
}

export function buildUrl(endpoint, params = null) {
	const apiRoot = window.location.protocol + '//' + window.location.host + '/api/';
	endpoint = endpoint.trim();

	// Do nothing more to absolute URLs:
	if (endpoint.indexOf('http') === 0) {
		return withQueryParams(endpoint, params);
	}

	// Remove leading slash:
	if (endpoint.indexOf('/') === 0) {
		endpoint = endpoint.substr(1);
	}

	return apiRoot + withQueryParams(endpoint, params);
}

/*
* Pass errors object to get a singular, flattened error message string
* format: `{key}: {message} {key2}: {message2}`
*/
export function parseError({ errors, message }) {
	if (!errors || errors.length === 0) {
		return message || '';
	}

	let msg = [];

	try {
		errors.forEach(err => {
			if (typeof err === 'string') {
				msg.push(err);
			} else {
				let keys = Object.keys(err);
				let msgs = keys.map(k => `${k}: ${err[k]}`);
				msg.push(msgs.join(' '));
			}
		});
	} catch (e) {
		console.error(e);
	}

	return msg.join(' ');
}

/*
* Pass errors object & field name to get the error message for a given field
* let nameErrorMessage = fieldError('name', e);
*/
export function fieldError(field, { errors }) {
	if (!errors || errors.length === 0) {
		return '';
	}

	try {
		let fieldError = errors.filter(e => e[field]);
		if (fieldError.length > 0) {
			return fieldError[0][field];
		}
	} catch (e) {
		console.error(e);
	}

	return '';
}
